import { FclIcon, LclIcon, SvgIconProps } from '@freighthub/silhouette-core'
import { ComponentType, FC } from 'react'

import { TRANSPORT_TYPE_FCL, TRANSPORT_TYPE_LCL, TTransportType } from '../domain/TransportType'

const TransportTypeIconsMap = {
  [TRANSPORT_TYPE_FCL]: FclIcon,
  [TRANSPORT_TYPE_LCL]: LclIcon,
}

type TTransportTypeIconProps = {
  transportType: TTransportType
} & SvgIconProps

export const TransportTypeIcon: FC<TTransportTypeIconProps> = (props) => {
  const { transportType, ...rest } = props
  const Icon: ComponentType<SvgIconProps> = TransportTypeIconsMap[transportType]
  return <Icon {...rest} />
}
